function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function getEarthDistance(lng1, lat1, lng2, lat2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

function getMostVisited(applicants, applicantsData, chunked) {
  let maxCount = 0;
  let p = null;

  Object.entries(applicants).forEach(e => {
    if (e[1] >= maxCount) {
      [p] = applicantsData[e[0]];
      [, maxCount] = e;
    }
  });
  p.count = maxCount;
  p.origin = p.origin || { lng: p.lng, lat: p.lat };
  // set date range for the selected (grouped) location
  if (chunked.length > 1) {
    const last = chunked[chunked.length - 1];
    p.firstTimestamp = chunked[0].timestamp;
    p.lastTimestamp = last.timestamp;
  }
  return p;
}

// connects points through the shorter route
function setShorterPath(locations, p) {
  const prev = locations[locations.length - 1];
  if (prev) {
    p.lng += p.lng - prev.lng > 180 ? -360 : (prev.lng - p.lng > 180 ? 360 : 0);
  }
  return p;
}

export function getMetricsRange(metricsRange, metric, k) {
  // Appliance report page doesn't have click event
  if (!metric) {
    return null;
  }
  if (!metricsRange) {
    return {
      max: {
        [k]: metric[k],
        [`${k}Timestamp`]: metric.timestamp
      },
      min: {
        [k]: metric[k],
        [`${k}Timestamp`]: metric.timestamp
      }
    };
  }
  if (metric[k] !== null) {
    if (metricsRange.max[k] < metric[k] || !metricsRange.max[k]) {
      metricsRange.max[k] = metric[k];
      metricsRange.max[`${k}Timestamp`] = metric.timestamp;
    }
    if (metricsRange.min[k] > metric[k] || !metricsRange.min[k]) {
      metricsRange.min[k] = metric[k];
      metricsRange.min[`${k}Timestamp`] = metric.timestamp;
    }
  }
  return metricsRange;
}

export function getReducedLocations(d, maxPointDistance) {
  const locations = [];
  let applicants = {};
  let applicantsData = {};
  let chunked = [];
  let groupedMetrics = [];

  d.locations.forEach((l0, j) => {
    const l = { ...l0 };
    const key = `${l.lng.toFixed(4)}|${l.lat.toFixed(4)}`;
    if (!applicants[key]) applicants[key] = 0;
    if (!applicantsData[key]) applicantsData[key] = [];
    applicants[key] += 1;
    applicantsData[key].push(l);
    chunked.push(l);
    groupedMetrics.push(l.metrics);

    const next = d.locations[j + 1];
    if (next) {
      const dist = getEarthDistance(l.lng, l.lat, next.lng, next.lat);
      if (dist >= maxPointDistance) {
        const location = getMostVisited(applicants, applicantsData, chunked);
        location.groupedMetrics = groupedMetrics;
        locations.push(
          setShorterPath(locations, location)
        );
        applicants = {};
        applicantsData = {};
        chunked = [];
        groupedMetrics = [];
      }
    } else {
      const location = getMostVisited(applicants, applicantsData, chunked);
      location.groupedMetrics = groupedMetrics;
      locations.push(
        setShorterPath(locations, location)
      );
    }
  });
  return locations;
}
